// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"d7ba84cc","237":"46ed4886","378":"8e948f73","397":"4b8cd83a","518":"a08c2fcc","571":"4c8fca2e","748":"c335d952","797":"c9b280e1","921":"857763c8"}[chunkId] + ".chunk.js";
};